import { render, staticRenderFns } from "./channelgoods.vue?vue&type=template&id=450f6cfc&scoped=true&"
import script from "./channelgoods.vue?vue&type=script&lang=js&"
export * from "./channelgoods.vue?vue&type=script&lang=js&"
import style0 from "./channelgoods.vue?vue&type=style&index=0&lang=css&"
import style1 from "./channelgoods.vue?vue&type=style&index=1&id=450f6cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f6cfc",
  null
  
)

export default component.exports